import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import moment from 'moment';
import { forEach, cloneDeep } from 'lodash';
import { EditableTable } from 'components/EditableTable';
import Paginate from 'components/Pagination';
import { groupSuggestionsByPage } from '../../../../../../utils/schedulingUtils';
import JobHistoryRow from 'JobHistoryRow';
import JobHistoryHeader from 'JobHistoryHeader';
import S from '../jobHistoryStyles.scss';
import { DISPLAY_DATE, RAILS_DATE } from 'config/constants';

const EMPTY_TABLE = (<div className={S.emptyTable}>
  <h4>No job history found</h4>
</div>);

const DENOMINATOR = 15;

class JobHistoryTable extends React.Component {
  constructor(props) {
    super(props);
    this.setRenderExcel = this.setRenderExcel.bind(this);
    this.setPage = this.setPage.bind(this);
    this.setSearch = this.setSearch.bind(this);
    const fullJobHistory = this.getJobHistory() || [];
    this.state = {
      fullJobHistory,
      filteredJobHistory: fullJobHistory,
      totalCount: fullJobHistory.length,
      currentPage: 1,
      search: '',
      renderExcel: false,
    };
  }

  setRenderExcel = val => this.setState({ renderExcel: val });

  setPage = page => this.setState({ currentPage: page });

  setSearch = (term) => {
    const { fullJobHistory } = this.state;
    const termCopy = term.toString();
    if (!termCopy) {
      this.setState({
        currentPage: 1,
        search: '',
        filteredJobHistory: fullJobHistory,
        totalCount: fullJobHistory.length });
    } else {
      const fullClone = cloneDeep(fullJobHistory);
      const filteredClone = fullClone.filter((appt) => {
        const valArr = [];
        forEach(appt, (val, key) => {
          let valCopy = val;
          if (typeof val === 'number') valCopy = valCopy.toString();
          if (key === 'phase') {
            if (this.noVal(valCopy)) valArr.push('n/a');
            valArr.push((valCopy.project_number || 'n/a').toString());
          } else valArr.push(valCopy.toLowerCase());
        });
        return valArr.some(val => val.includes(termCopy.toLowerCase()));
      });
      this.setState({
        currentPage: 1,
        search: termCopy,
        filteredJobHistory: filteredClone,
        totalCount: filteredClone.length,
      });
    }
  }

  getJobHistory = () => {
    const { crews } = this.props;
    if (!crews.length) return [];
    const list = [];
    crews.forEach((c) => {
      const { id: crewId = null, appointments: appts = [] } = c;
      if (appts.length) {
        appts.forEach((a) => {
          const { id = null, assignee = 'N/A', kind = 'N/A', phase = 'N/A',
                  start_date = 'N/A', end_date = 'N/A' } = a;
          list.push({
            id,
            crewId,
            crew: assignee,
            apptType: kind.replace('_', ' '),
            startDate: this.noVal(start_date) ? start_date : this.formatDate(start_date),
            endDate: this.noVal(end_date) ? end_date : this.formatDate(end_date),
            phase,
          });
        });
      }
    });
    return list;
  };

  getHistoryByPage = () => {
    const { filteredJobHistory = [], currentPage } = this.state;
    if (!filteredJobHistory.length) return [];
    const paginatedHistory = groupSuggestionsByPage(cloneDeep(filteredJobHistory), DENOMINATOR);
    return paginatedHistory[currentPage - 1] || [];
  };

  noVal = val => !val || val === 'N/A';

  formatDate = date => moment(date, RAILS_DATE).format(DISPLAY_DATE);

  render = () => {
    const { filteredJobHistory, renderExcel, totalCount, currentPage, search } = this.state;
    const historyByPage = this.getHistoryByPage();
    return (<div className={S.jobHistoryTable}>
      <JobHistoryHeader
        setRenderExcel={this.setRenderExcel}
        renderExcel={renderExcel}
        appts={filteredJobHistory}
        search={search}
        setSearch={this.setSearch}
      />
      {historyByPage.length ? (<Fragment>
        <EditableTable isEditable={false} hasCreatableRow={false}>
          {historyByPage.map(appt => (<JobHistoryRow key={appt.id} appt={appt} />))}
        </EditableTable>
        <br />
        <div className={S.paginationContainer}>
          <Paginate
            denominator={DENOMINATOR}
            currentPage={currentPage}
            totalCount={totalCount}
            getListPage={page => this.setPage(page)}
            buttonStyle="listPageButton"
          />
        </div>
        <br />
      </Fragment>) : EMPTY_TABLE}
    </div>);
  }
}

JobHistoryTable.propTypes = { crews: PropTypes.array };

JobHistoryTable.defaultProps = { crews: [] };

export default JobHistoryTable;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/reports/jobHistory/components/JobHistoryTable.jsx